import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../shared/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
rateTableId:number=0;
activateNetworkTab = false;
@Input('progressvalue') progress;
@Input() title: string;
@Input() routeName:string;

  constructor(public _dataService: DataService,
              private route: ActivatedRoute,
              public router: Router ) {
   }

  ngOnInit() {
     this.route.paramMap.subscribe(params => {
     this.rateTableId=parseInt(params.get('Id'));
   });
  }
  isBackButtonEnabled() {
    return !(this.routeName === 'wbquote'
    && this._dataService.isFromBrokerMobileApp());
  }

  getUrlByRateTableId(key){
    return '/'+key+'/'+this.rateTableId;
  }
  goBackButton(){
    if(this.routeName == 'wbquote'){
      this._dataService.redirect();
    }else{

      this.router.navigateByUrl('/'+this.routeName+'/' + this.rateTableId);
    }

  }
  gotoWBQuote(){
    this._dataService.redirect();

  }



}
